import { render, staticRenderFns } from "./MenuOpenLinkButton.vue?vue&type=template&id=bbb187e4&"
import script from "./MenuOpenLinkButton.vue?vue&type=script&lang=ts&"
export * from "./MenuOpenLinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports